import React, { useState, useEffect } from 'react';
import Header from '../components/header';
import Footers from '../components/footers';
import { serverURL } from '../constants';
import axios from 'axios';
import { GiCancel } from "react-icons/gi";
import { FaRankingStar, FaInfinity } from "react-icons/fa6";
import { Button, Card, Spinner } from 'flowbite-react';
import { useLocation, useNavigate } from 'react-router-dom';

const Pricing = () => {
    const { state } = useLocation();
    const { header } = state || false;
    const navigate = useNavigate();
    const [plans, setPlans] = useState([]);
    const [loading, setLoading] = useState(true);
    const [expandedItem, setExpandedItem] = useState(null);

    useEffect(() => {
        async function fetchPlans() {
            try {
                const response = await axios.get(serverURL + '/api/getplans');
                setPlans(response.data.filter(p => p.active));
            } catch (error) {
                console.error(error);
            }
            setLoading(false);
        }
        fetchPlans();
    }, []);

    const faq = [
        { question: 'What is our cancellation policy?', answer: <p>You can read our cancellation policy <span className='text-blue-800 underline cursor-pointer' onClick={() => navigate("/cancellation")}>here</span></p> },
        { question: 'What is our refund policy?', answer: <p>You can read our refund policy <span className='text-blue-800 underline cursor-pointer' onClick={() => navigate("/refund")}>here</span></p> },
        { question: 'What is our billing policy?', answer: <p>You can read our billing policy <span className='text-blue-800 underline cursor-pointer' onClick={() => navigate("/billing")}>here</span></p> },
        { question: 'What payment gateways are available?', answer: 'We support PayPal, Stripe, Razorpay, Paystack, and Flutterwave.' },
    ];

    const PlanCard = ({ plan, featured }) => {
        const features = (plan.features || '').split('\n').filter(f => f.trim());
        const userType = sessionStorage.getItem('type');
        const isCurrentPlan = userType === plan.name;

        return (
            <div className={`border ${featured ? 'border-2 border-black dark:border-white' : 'border-gray-300 dark:border-gray-700'} rounded-lg p-6 w-full max-w-sm`}>
                {featured && <p className='text-xs font-bold text-white bg-black dark:bg-white dark:text-black px-3 py-1 rounded-full inline-block mb-3'>Most Popular</p>}
                <h3 className='text-2xl font-black dark:text-white'>{plan.name}</h3>
                <div className='mt-2 mb-4'>
                    <span className='text-5xl font-black dark:text-white'>${plan.cost}</span>
                    {plan.duration && <span className='text-gray-500'>/{plan.duration}</span>}
                </div>
                <div className='space-y-2 mb-6'>
                    {features.map((f, i) => (
                        <div key={i} className='flex items-center gap-2 text-sm dark:text-white'>
                            <svg className="w-4 h-4 text-green-600 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
                                <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd"/>
                            </svg>
                            {f}
                        </div>
                    ))}
                </div>
                {isCurrentPlan ? (
                    <button className='w-full border border-gray-300 text-gray-400 font-bold py-3 rounded-lg cursor-default'>Current Plan</button>
                ) : sessionStorage.getItem('auth') ? (
                    <button onClick={() => navigate('/payment', { state: { plan: plan.name } })}
                        className={`w-full font-bold py-3 rounded-lg ${featured ? 'bg-black dark:bg-white text-white dark:text-black hover:opacity-90' : 'border border-black dark:border-white text-black dark:text-white hover:bg-gray-50 dark:hover:bg-gray-900'}`}>
                        {plan.cost === 0 ? 'Get Started' : 'Subscribe'}
                    </button>
                ) : (
                    <button onClick={() => navigate('/signup')}
                        className={`w-full font-bold py-3 rounded-lg ${featured ? 'bg-black dark:bg-white text-white dark:text-black hover:opacity-90' : 'border border-black dark:border-white text-black dark:text-white hover:bg-gray-50 dark:hover:bg-gray-900'}`}>
                        Get Started
                    </button>
                )}
            </div>
        );
    };

    const benefitStyle = {
        "root": {
            "base": "max-w-sm max-md:max-w-xs flex rounded-none border border-black bg-white shadow-none dark:border-white dark:bg-black m-4",
            "children": "flex h-full flex-col justify-center gap-3 p-5",
            "horizontal": { "off": "flex-col", "on": "flex-col md:max-w-xl md:flex-row" },
            "href": "hover:bg-white dark:hover:bg-black"
        },
        "img": { "base": "", "horizontal": { "off": "rounded-none", "on": "h-96 w-full rounded-none object-cover md:h-auto md:w-48 md:rounded-none md:rounded-l-lg" } }
    };

    return (
        <div className='min-h-screen flex flex-col'>
            <Header isHome={header} className="sticky top-0 z-50" />
            <div className='dark:bg-black flex-1'>
                <div className='flex-1 flex flex-col items-center justify-center'>
                    <h1 className="text-6xl font-black mt-14 max-md:text-3xl dark:text-white">Pricing</h1>
                    <p className="text-center text-gray-500 mt-4 max-w-lg font-medium max-md:text-xs">
                        Choose the right plan for your education and future
                    </p>

                    {loading ? (
                        <div className='py-20'><Spinner size="xl" className='fill-black dark:fill-white' /></div>
                    ) : (
                        <div className="flex flex-wrap justify-center gap-6 py-14 px-4">
                            {plans.map((plan, i) => (
                                <PlanCard key={plan._id} plan={plan} featured={i === 1} />
                            ))}
                        </div>
                    )}

                    <div className="dark:bg-black pt-16">
                        <div className="flex items-center justify-center text-center">
                            <div className="text-4xl font-black dark:text-white max-md:text-2xl">Pricing Benefits</div>
                        </div>
                        <div className="lg:flex pt-10 max-md:py-14">
                            <Card theme={benefitStyle}>
                                <FaInfinity className="text-4xl max-md:text-3xl dark:text-white" />
                                <h5 className='text-xl font-black tracking-tight text-black dark:text-white'>Flexible Pricing</h5>
                                <p className='font-normal text-sm text-black dark:text-white'>Tailor costs to usage needs for optimal budgeting flexibility</p>
                            </Card>
                            <Card theme={benefitStyle}>
                                <FaRankingStar className="text-4xl max-md:text-3xl dark:text-white" />
                                <h5 className='text-xl font-black tracking-tight text-black dark:text-white'>Upgrade Anytime</h5>
                                <p className='font-normal text-sm text-black dark:text-white'>Seamlessly scale plans to match evolving requirements at any moment</p>
                            </Card>
                            <Card theme={benefitStyle}>
                                <GiCancel className="text-4xl max-md:text-3xl dark:text-white" />
                                <h5 className='text-xl font-black tracking-tight text-black dark:text-white'>Cancel Anytime</h5>
                                <p className='font-normal text-sm text-black dark:text-white'>Terminate subscription anytime, providing ultimate flexibility and control</p>
                            </Card>
                        </div>
                    </div>

                    <div className="flex items-center justify-center text-center flex-col px-6 max-md:px-2 pt-16">
                        <h1 className="text-4xl font-black dark:text-white max-md:text-2xl mb-10">Frequently asked questions</h1>
                        <ul>
                            {faq.map((item, index) => (
                                <li key={index} className="mb-4">
                                    <Button
                                        className='w-96 max-sm:max-w-xs mb-2 items-start justify-start text-start border-black dark:border-white dark:bg-black dark:text-white bg-white text-black font-bold rounded-none enabled:hover:bg-white enabled:focus:bg-white enabled:focus:ring-transparent dark:enabled:hover:bg-black dark:enabled:focus:bg-black dark:enabled:focus:ring-transparent'
                                        onClick={() => setExpandedItem(expandedItem === index ? null : index)}
                                    >
                                        {item.question}
                                    </Button>
                                    {expandedItem === index && (
                                        <div className='max-w-sm max-sm:max-w-xs mb-4 text-sm text-black dark:text-white'>{item.answer}</div>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="flex items-center justify-center text-center py-16 flex-col">
                        <div className="text-4xl font-black dark:text-white max-md:text-2xl">Still have questions?</div>
                        <Button className='max-w-xs my-10 items-center justify-center text-center border-black dark:border-white dark:bg-black dark:text-white bg-white text-black font-bold rounded-none w-full enabled:hover:bg-white enabled:focus:bg-white enabled:focus:ring-transparent dark:enabled:hover:bg-black dark:enabled:focus:bg-black dark:enabled:focus:ring-transparent' onClick={() => navigate("/contact")}>Contact</Button>
                    </div>
                </div>
            </div>
            <Footers className="sticky bottom-0 z-50" />
        </div>
    );
};

export default Pricing;
